<template>
    <div class="total-commitment">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <h4 class="mb-0">Total Commitment (RM)</h4>
            </b-card-header>
            <div class="px-3 py-2">
                <h2 class="mb-0 font-weight-600">{{ totalNewCommitment | moneyFormatter }}</h2>
                <!-- <el-button type="text" disabled>
                    View Financial Proposal
                    <b-icon icon="chevron-right"></b-icon>
                </el-button><br>
                <el-button type="text" class="ml-0" disabled>
                    View Variable Expenses
                    <b-icon icon="chevron-right"></b-icon>
                </el-button> -->
            </div>
        </b-card>
    </div>
</template>
<script>
    import { Card, Button } from 'element-ui'

    export default {
        name: 'total-commitment',
        props: ['commitment'],
        components: {
            [Card.name]: Card,
            [Button.name]: Button,
        },
        computed:{
            totalNewCommitment(){
                var total = 0
                this.commitment.forEach(item => {
                    if(item.commitment_is_manual === 0){
                        item.commitment_sub_items.forEach(sub_item => {     
                            total += parseFloat(sub_item.commitment_new_installment)
                        });
                    }else{
                        total += parseFloat(item.commitment_new_installment)
                    }
                });
                return total
            },
        }   
    }

</script>